import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
  Stack,
} from "@mui/material";
import { FiPlus } from "react-icons/fi";
import { FaMinus } from "react-icons/fa";
import { FaPlus } from "react-icons/fa";

function FAQ() {
  const [expanded, setExpanded] = useState(false);

  const handleToggle = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Stack
      sx={{
        // border: "1px solid blue",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "'Roboto', sans-serif",
        // marginBottom: {
        //   xs: "28px",
        //   sm: "28px",
        //   md: "40px",
        //   lg: "40px",
        //   xl: "80px",
        // },
        // paddingTop: { xl: "40px", lg: "80px", md: "0px", sm: "0px", xs: "0px" },
        paddingBottom: {
          xl: "60px",
          lg: "40px",
          md: "0px",
          sm: "0px",
          xs: "32px",
        },
        // backgroundColor: "rgb(218 233 248)",
        // gap: 2,
      }}
    >
      <Stack
        sx={{
          // border: "1px solid red",
          width: { xl: "72%", lg: "89%", md: "89%", sm: "100%", xs: "92%" },
          display: "flex",
          flexDirection: "column",
          marginBottom: { xl: "0px", lg: "0px", md: "30px" },
        }}
      >
        <Stack
          sx={{
            fontFamily: "'Roboto', sans-serif",
            fontSize: {
              xs: "24px",
              sm: "30px",
              md: "28px",
              lg: "40px",
              xl: "40px",
            },
            lineHeight: {
              xs: "28px",
              sm: "36px",
              md: "32px",
              lg: "48px",
              xl: "48px",
            },
            fontWeight: 600,
            color: "rgb(5 78 146)",
            textAlign: "center",
            marginBottom: {
              xs: "20px",
              sm: "20px",
              md: "20px",
              lg: "20px",
              xl: "20px",
            },
            marginTop: {
              xs: "20px",
              sm: "20px",
              md: "40px",
              lg: "64px",
              xl: "64px",
            },
            // border: "1px solid red",
            display: "flex",
            flexDirection: "row",
          }}
        >
          {/* <Stack
            sx={{
              width: { xl: "6px", lg: "6px", xs: "4px" },
              // height: { xl: "100%", lg: "100%", xs: "100%" },
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              border: "1px solid #1e3a8a",
              // backgroundColor: "rgb(5 78 146)",
              backgroundColor: "#1e3a8a",
              marginRight: "8px",
              borderTopRightRadius: "8px", // Adjust the value as needed
              borderBottomRightRadius: "8px", // Adjust the value as needed
            }}
          >
            <h4 style={{ color: "#1e3a8a" }}>{""}</h4>
          </Stack> */}

          <Stack
            sx={{
              // border: "1px solid red",
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Stack
              sx={{
                width: { xl: "6px", lg: "6px", xs: "4px" },
                // height: { xl: "100%", lg: "100%", xs: "100%" },
                height: {
                  xs: "20px",
                  sm: "44px",
                  md: "28px",
                  lg: "40px",
                  xl: "40px",
                },
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                border: "1px solid rgb(5 78 146)",
                // backgroundColor: "rgb(5 78 146)",
                backgroundColor: "rgb(5 78 146)",
                marginRight: {
                  xs: "8px",
                  sm: "8px",
                  md: "12px",
                  lg: "12px",
                  xl: "12px",
                },
                borderTopRightRadius: "8px", // Adjust the value as needed
                borderBottomRightRadius: "8px", // Adjust the value as needed
              }}
            >
              <h4 style={{ color: "rgb(5 78 146)" }}>{""}</h4>
            </Stack>
          </Stack>
          <span style={{ display: "inline-flex", alignItems: "center" }}>
            Frequently ask questions
          </span>
        </Stack>

        <Stack
          sx={{
            width: "100%",
            fontFamily: "'Roboto', sans-serif",
            fontSize: {
              xs: "16px",
              sm: "16px",
              md: "16px",
              lg: "24px",
              xl: "24px",
            },
            lineHeight: {
              xs: "24px",
              sm: "28px",
              md: "32px",
              lg: "32px",
              xl: "32px",
            },
            fontWeight: { xs: 400, sm: 400, md: 400, lg: 400, xl: 400 },
            color: "#333",
            border: "1px solid #f1f8ff",
            textAlign: "left",
            // border: "1px solid rgb(218 233 248)",
            padding: 1,
            borderRadius: "8px",
            backgroundColor: "#f1f8ff",
            marginBottom: {
              xs: "20px",
              sm: "20px",
              md: "20px",
              lg: "64px",
              xl: "64px",
            },
          }}
        >
          <span>
            Find quick answers about{" "}
            <span style={{ fontWeight: 600 }}>
              <span style={{ color: "#054E91" }}>Vertex</span>{" "}
              <span style={{ color: "#53AFE4" }}>Suite</span>
            </span>{" "}
            WhatsApp Business Platform. Learn how automation works, what
            templates you can use, pricing details and real use cases -
            everything explained simply to help you get started easily and
            confidently.
          </span>
        </Stack>
      </Stack>
      <Stack
        sx={{
          // border: "1px solid red",
          width: { xl: "72%", lg: "89%", md: "89%", sm: "100%", xs: "92%" },

          //glassmorphic ui
          backgroundColor: "rgba(255, 255, 255, 0.5)",
          backdropFilter: "blur(12px)",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
          // border: "1px solid rgba(255, 255, 255, 0.2)",
          // border: "1px solid red",
          transition: "all 0.5s ease-in-out",
          fontFamily: "'Roboto', sans-serif",
          marginBottom: { xl: "24px", lg: "0px", md: "56px" },
          //for shine
        }}
      >
        <Accordion
          expanded={expanded === "panel1"}
          onChange={handleToggle("panel1")}
          sx={{
            "&:hover": {
              backgroundColor: "#f4f4ff",
            },
            backgroundColor: expanded === "panel1" ? "#f4f4ff" : "none",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel1" ? (
                <FaMinus style={{ fontSize: "24px", color: "#5858e0" }} />
              ) : (
                <FaPlus style={{ fontSize: "24px", color: "#5858e0" }} />
              )
            }
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography
              sx={{
                fontSize: { xl: "20px", lg: "20px", sm: "20px", xs: "16px" },
                fontWeight: 600,
                color: "rgb(0, 0, 0)",
                lineHeight: "31px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              What is WhatsApp Business API?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                color: "rgb(0, 0, 0)",
                lineHeight: "25px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              WhatsApp Business API enables businesses to automate customer
              communication, send notificationsand provide a personalized
              experience at scale using WhatsApp.
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expanded === "panel2"}
          onChange={handleToggle("panel2")}
          sx={{
            "&:hover": {
              backgroundColor: "#f4f4ff",
            },
            backgroundColor: expanded === "panel2" ? "#f4f4ff" : "none",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel2" ? (
                <FaMinus style={{ fontSize: "24px", color: "#5858e0" }} />
              ) : (
                <FaPlus style={{ fontSize: "24px", color: "#5858e0" }} />
              )
            }
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography
              sx={{
                fontSize: { xl: "20px", lg: "20px", sm: "20px", xs: "16px" },
                fontWeight: 600,
                color: "rgb(0, 0, 0)",
                lineHeight: "31px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              How is WhatsApp Business API different from the WhatsApp Business
              App?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                color: "rgb(0, 0, 0)",
                lineHeight: "25px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              The API is designed for medium to large businesses, offering
              advanced features like automation, broadcastingand CRM
              integration, while the app is for small businesses with limited
              functionality.
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expanded === "panel3"}
          onChange={handleToggle("panel3")}
          sx={{
            "&:hover": {
              backgroundColor: "#f4f4ff",
            },
            backgroundColor: expanded === "panel3" ? "#f4f4ff" : "none",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel3" ? (
                <FaMinus style={{ fontSize: "24px", color: "#5858e0" }} />
              ) : (
                <FaPlus style={{ fontSize: "24px", color: "#5858e0" }} />
              )
            }
            aria-controls="panel3a-content"
            id="panel3a-header"
          >
            <Typography
              sx={{
                fontSize: { xl: "20px", lg: "20px", sm: "20px", xs: "16px" },
                fontWeight: 600,
                color: "rgb(0, 0, 0)",
                lineHeight: "31px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              Can businesses of all sizes use the WhatsApp Business API?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                color: "rgb(0, 0, 0)",
                lineHeight: "25px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              Yes, businesses of all sizes can use it. However, it is best
              suited for medium to large-scale businesses requiring automation
              and bulk messaging capabilities.
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expanded === "panel4"}
          onChange={handleToggle("panel4")}
          sx={{
            "&:hover": {
              backgroundColor: "#f4f4ff",
            },
            backgroundColor: expanded === "panel4" ? "#f4f4ff" : "none",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel4" ? (
                <FaMinus style={{ fontSize: "24px", color: "#5858e0" }} />
              ) : (
                <FaPlus style={{ fontSize: "24px", color: "#5858e0" }} />
              )
            }
            aria-controls="panel4a-content"
            id="panel4a-header"
          >
            <Typography
              sx={{
                fontSize: { xl: "20px", lg: "20px", sm: "20px", xs: "16px" },
                fontWeight: 600,
                color: "rgb(0, 0, 0)",
                lineHeight: "31px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              What documents are required for onboarding?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                color: "rgb(0, 0, 0)",
                lineHeight: "25px",
                marginBottom: "8px", // Add spacing below the heading
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              You'll need:
            </Typography>

            <ul
              style={{
                fontSize: "16px",
                fontWeight: 400,
                color: "rgb(0, 0, 0)",
                lineHeight: "25px",
                paddingLeft: "20px", // Indentation for the bullet points
                margin: "0", // Remove default margin
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              <li>GST Number (or MSME Certificate if GST is not available)</li>
              <li>A verified business name</li>
              <li>Facebook Business Manager account</li>
              <li>A phone number not registered on WhatsApp</li>
            </ul>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expanded === "panel5"}
          onChange={handleToggle("panel5")}
          sx={{
            "&:hover": {
              backgroundColor: "#f4f4ff",
            },
            backgroundColor: expanded === "panel5" ? "#f4f4ff" : "none",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel5" ? (
                <FaMinus style={{ fontSize: "24px", color: "#5858e0" }} />
              ) : (
                <FaPlus style={{ fontSize: "24px", color: "#5858e0" }} />
              )
            }
            aria-controls="panel5a-content"
            id="panel5a-header"
          >
            <Typography
              sx={{
                fontSize: { xl: "20px", lg: "20px", sm: "20px", xs: "16px" },
                fontWeight: 600,
                color: "rgb(0, 0, 0)",
                lineHeight: "31px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              Can I use my existing WhatsApp number?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                color: "rgb(0, 0, 0)",
                lineHeight: "25px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              No, you need a phone number that is not already linked to a
              personal or business WhatsApp account.
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expanded === "panel6"}
          onChange={handleToggle("panel6")}
          sx={{
            "&:hover": {
              backgroundColor: "#f4f4ff",
            },
            backgroundColor: expanded === "panel6" ? "#f4f4ff" : "none",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel6" ? (
                <FaMinus style={{ fontSize: "24px", color: "#5858e0" }} />
              ) : (
                <FaPlus style={{ fontSize: "24px", color: "#5858e0" }} />
              )
            }
            aria-controls="panel6a-content"
            id="panel6a-header"
          >
            <Typography
              sx={{
                fontSize: { xl: "20px", lg: "20px", sm: "20px", xs: "16px" },
                fontWeight: 600,
                color: "rgb(0, 0, 0)",
                lineHeight: "31px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              How long does the onboarding process take?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                color: "rgb(0, 0, 0)",
                lineHeight: "25px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              Onboarding typically takes 5–7 business days after submission of
              all required documents.
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expanded === "panel7"}
          onChange={handleToggle("panel7")}
          sx={{
            "&:hover": {
              backgroundColor: "#f4f4ff",
            },
            backgroundColor: expanded === "panel7" ? "#f4f4ff" : "none",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel7" ? (
                <FaMinus style={{ fontSize: "24px", color: "#5858e0" }} />
              ) : (
                <FaPlus style={{ fontSize: "24px", color: "#5858e0" }} />
              )
            }
            aria-controls="panel7a-content"
            id="panel7a-header"
          >
            <Typography
              sx={{
                fontSize: { xl: "20px", lg: "20px", sm: "20px", xs: "16px" },
                fontWeight: 600,
                color: "rgb(0, 0, 0)",
                lineHeight: "31px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              Is GST mandatory?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                color: "rgb(0, 0, 0)",
                lineHeight: "25px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              No, if you don't have a GST number, you can use an MSME
              certificate to onboard.
            </Typography>
          </AccordionDetails>
        </Accordion>
        
      </Stack>
    </Stack>
  );
}

export default FAQ;
